import type { ReactNode } from "react";
import { Link } from "react-router";
import { useSession } from "../lib/auth.js";

/** Renders children only for signed-in users; otherwise a short prompt. */
export function AuthGate({ children }: { children: ReactNode }) {
  const { data, isPending } = useSession();
  if (isPending) return <p className="muted">読み込み中…</p>;
  if (!data) {
    return (
      <div className="card">
        <p>この機能はログインが必要です。</p>
        <Link className="btn" to="/login">
          ログイン / 新規登録
        </Link>
      </div>
    );
  }
  return <>{children}</>;
}
